"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransation = exports.langTypes = void 0;
var fr_1 = __importDefault(require("./fr"));
var en_1 = __importDefault(require("./en"));
var langTypes;
(function (langTypes) {
    langTypes["FR"] = "fr";
    langTypes["EN"] = "en";
})(langTypes = exports.langTypes || (exports.langTypes = {}));
function getTransation(selector, args) {
    return function (i18n) {
        var _selector = selector(i18n);
        if (args && typeof _selector === "string") {
            var keys = Object.keys(args);
            if (keys.length !== 0) {
                return keys.reduce(function (acc, current) {
                    var e = "{" + current + "}";
                    if (acc.includes(e)) {
                        var result = acc.split(e);
                        return result[0] + args[current] + result[1];
                    }
                    else {
                        return acc;
                    }
                }, _selector);
            }
        }
        return _selector;
    };
}
exports.getTransation = getTransation;
function i18n(lang) {
    switch (lang) {
        case langTypes.FR:
            return fr_1.default;
        case langTypes.EN:
            return en_1.default;
        default:
            return fr_1.default;
    }
}
exports.default = i18n;
